<template>
<v-container grid-list-xl fluid class="text-xs-center pa-0">
  <v-card class="pa-3 grey lighten-5 card-r">
    <div class="w-100 text-xs-left">
      <v-btn @click="addw = true"
              class="sim primary no-shadow card-r ">
              <i class="fas fa-plus-circle mr-2"></i> 
                      Create Exam Package</v-btn>
    </div>
    <v-dialog v-model="addw" max-width="1000">
      <v-card class="pa-3 card-r grey lighten-4">
        <!-- <v-toolbar class="primary  card-r pl-3 mb-3 text-white"> -->
          <div class="textColor pa-1 f-30 font-weight-medium"> Create Exam Package</div>
        <!-- </v-toolbar> -->
        <!--<div class="textColor pa-1 f-30 font-weight-medium"></div>-->
        <v-flex xs12>
          <v-progress-circular
            indeterminate
            v-if=loading
            color="primary"
          ></v-progress-circular>
          <v-alert
            :value="true"
            :type="alertType"
            :icon="alertType"
            v-if="alertMessage"
            outline>
            {{alertMessage}}
          </v-alert>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs6 class="pl-1">
            <v-text-field v-model="packagaData.name" solo label="Package Name"></v-text-field>
          </v-flex>
          <v-flex xs3 class="pl-1">
            <v-text-field solo v-model="packagaData.valid_for" label="valid Days"></v-text-field>
          </v-flex>
          <v-flex xs3 class="pl-1">
            <v-text-field solo v-model="packagaData.price" label="price"></v-text-field>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <v-combobox solo :items="testsList" v-model="selectedTests" item-value="id"  item-text="name" label="Select Tests" multiple chips>
              <template slot="selection" slot-scope="data">

                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="JSON.stringify(data.item)"
                  class="v-chip--select-multi"
                  @input="data.parent.selectItem(data.item)">
                  <!-- <v-avatar
                    class="accent white--text"
                    tile="true"
                    size="36px"
                    color="grey lighten-4">
                    <img  :src="data.item.picture">
                  </v-avatar> -->
                  {{ data.item.name }}</v-chip>
              </template>
            </v-combobox>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <v-textarea v-model="packagaData.description" rows="2" solo name="input-7-1" label="Description"></v-textarea>
          </v-flex>

          <v-flex xs12 class="text-xs-right pa-0">
            <v-btn @click="createPackage()" color="primary card-r no-shadow right text-white" dark>Save</v-btn>
            <v-btn @click="addw = false" color="grey card-r no-shadow right text-white" dark>Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- <v-layout v-show="show" row wrap>
      <v-flex xs12 class="pb-0">
        <div class="w-100 text-xs-left font-weight-bold text-primary">Create A New Package</div>
      </v-flex>
      <v-flex xs6 class="pb-0">
        <v-text-field solo label="Package Name"></v-text-field>
      </v-flex>
      <v-flex xs3 class="pb-0">
        <v-text-field solo label="valid Days"></v-text-field>
      </v-flex>
      <v-flex xs3 class="pb-0">
        <v-text-field solo label="price"></v-text-field>
      </v-flex>
    </v-layout> -->
    <v-flex xs12>
        <v-progress-circular
                    indeterminate
                    v-if=loading
                    color="primary"
        ></v-progress-circular>
        <v-alert
          :value="true"
          :type="alertType"
          :icon="alertType=='success'?'check_circle':'warning'"
          v-if="alertMessage"
          outline>
          {{alertMessage}}
        </v-alert>
     </v-flex>
    <v-layout v-show="show" row wrap>
     <v-flex xs6 class="pb-0">
       <v-text-field v-model="packagaData.name" solo label="Exam Package Name"></v-text-field>
     </v-flex>
     <v-flex xs3 class="pb-0">
       <v-text-field solo v-model="packagaData.valid_for" label="valid Days"></v-text-field>
     </v-flex>
     <v-flex xs3 class="pb-0">
       <v-text-field solo v-model="packagaData.price" label="price"></v-text-field>
     </v-flex>
     <v-flex xs12>
       <v-combobox solo :items="testsList" v-model="selectedTests" item-value="id"  item-text="name" label="Select Tests" multiple chips>
         <template slot="selection" slot-scope="data">

           <v-chip
             :selected="data.selected"
             :disabled="data.disabled"
             :key="JSON.stringify(data.item)"
             class="v-chip--select-multi"
             @input="data.parent.selectItem(data.item)">
            <v-avatar
                class="accent white--text"
                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
          </template>
        </v-combobox>
      </v-flex>
      <v-flex xs12>
        <v-textarea rows="2" solo name="input-7-1" label="Description"></v-textarea>
      </v-flex>
       <v-flex xs12 class="text-xs-right pa-0">
         <v-btn color="primary card-r no-shadow right" v-on:click='show = !show' dark>Add Exam Package</v-btn>
       </v-flex>
     </v-layout>

  <v-layout row wrap class=" text-xs-center">
    <v-flex d-flex lg3 xs12 md6 sm6 v-for="n in TestPackages">
      <v-card class=" white text-white shadow-1 card-r ">
        <v-card class="mainBackG no-shadow">
          <div class="f-30 pt-2 text-xs-center mb--8 font-weight-bold text-white">{{n.valid_for}}</div>
          <div class="text-xs-center text-white opacity--5 f-20 font-weight-bold">Days</div>
        </v-card>
        <v-layout xs12>
          <v-flex xs12 class="text-xs-left f-15 text-primary ml-3 mt-2 mr-3 mb-0">
            <div class="text-xs-center text-primary f-15 font-weight-bold w-break">{{n.name}}</div>
            <!-- <div class="text-xs-center text-primary mt-2 f-15 font-weight-bold">30 Days Trial</div> -->
            <div v-if="n.description!=null" class="text-xs-center-justify text-primary mt-2 f-12 w-break">{{n.description.substring(0,50)}}</div>
            <!-- <div class="text-xs-center text-primary mt-2 f-15 font-weight-bold">30 Day Trial</div> -->
          </v-flex>
        </v-layout>
        <v-flex xs12 class="text-xs-center pt-0 pb-0">
          <div class=" f-15 font-weight-bold opacity--5 text-blue-grey">Total Cost</div>
          <div class="font-weight-bold f-20 text-blue-grey mb-3 w-break">{{n.price}} Kr</div>
        </v-flex>
        <v-flex xs12 class="text-xs-center pt-0">
          <v-btn class="grey" icon @click="deletePackage(n.id)"><v-icon class="f-18 text-white">delete</v-icon></v-btn>
          <v-btn class="grey" icon :to="'editpackages/'+n.id"><v-icon class="f-18 text-white">edit</v-icon></v-btn>
        </v-flex>
      </v-card>
    </v-flex>
    <!-- </v-dialog> -->
  </v-layout>
  </v-card>

</v-container>
</template>
<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
	import { mapState } from 'vuex'

  export default {
    data: () => ({
      loading: false,
      deleted: false,
      addw: false,
      alertMessage:'',
      alertType:'',
      workMin: ['45', '90', '135', '180'],
      typs: ['Random', 'Mannual'],
      show: false,
      items: [
        'Tests 1',
        'Tests 2',
        'Tests 3',
        'Tests 4',
        'Tests 5',
        'Tests 6',
        'Tests 7',
        'Tests 8',
        'Tests 9',
        'Tests 10'
      ],
      packagaData:{
        name:'',
        description:'',
        valid_for:'',
        price:'',
      },
      selectedTests:''
    }),
    created:function(){
      this.loadTestPackages()
    },
    methods:{
      deletePackage(packageId){
        this.loading=true
        let self=this
        api.postData('driver/deleteTestPackage/'+packageId)
        .then(res=>{
          if(res.status==201){
            self.loading=false
            self.alertType="success"
            self.alertMessage="Exam Package is successfully deleted"
            self.loadTestPackages()
          }
        }).catch(err=>{
            self.loading=false
            self.alertType="error"
            self.alertMessage="Failed to delete"
        })
      },
      loadTestPackages(){
          api.postData('driver/viewTestPackages')
          .then(res=>{
            Store.dispatch('setTestPackages', res.data)
          })
      },
      createPackage(){
        this.loading=true
        this.alertMessage=''
        this.alertType=''
        let self=this
        let theory_test=this.selectedTests
        let selectedTests=[]
        if(theory_test){
          theory_test.forEach(element => {
            selectedTests.push(element.id)
          });
        }

        let Data={
          valid_for:this.packagaData.valid_for,
          price:parseInt(this.packagaData.price),
          theory_test:selectedTests,
          description:this.packagaData.description,
          name:this.packagaData.name
        }
        api.postData('driver/createTestPackage',Data)
        .then(res=>{
          if(res.status==201){
            self.loading=false
            self.alertMessage="Exam Package is successfully created"
            self.alertType='success'
            self.show=false
            self.addw = false
            self.loadTestPackages()
            // router.push('/examstab#packages')
          }else{
            self.alertType='error'
            self.alertMessage="Failed to create"
          }

        }).catch(err=>{
          self.loading=false
          self.alertType='error'
          self.alertMessage="Failed to create"
        })
      }
    },
    computed: {
      ...mapState({
        TestPackages: 'TestPackages',
        testsList: 'testsList'
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/Packages.vue